import { render, staticRenderFns } from "./KeyResource.vue?vue&type=template&id=537414d4&scoped=true&"
import script from "./KeyResource.vue?vue&type=script&lang=js&"
export * from "./KeyResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537414d4",
  null
  
)

export default component.exports